import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {CourseVideoResponse} from 'src/api/ProactApiClient';
import {Pill} from 'src/design/atoms/Pill';
import {ActiveInactivePills} from 'src/shared/constants/PillConstants';
import {ActiveStateDataOptions} from 'src/shared/constants/columnFilterData';

export const useCourseVideoColumns = () => {
  const columns = useMemo<MRT_ColumnDef<CourseVideoResponse>[]>(
    () => [
      {
        accessorKey: 'title',
        header: 'Title',
      },
      {
        accessorKey: 'description',
        header: 'Description',
      },
      {
        accessorKey: 'active',
        header: 'Active',
        enableColumnFilterModes: false,
        filterVariant: 'multi-select',
        mantineFilterSelectProps: {
          data: ActiveStateDataOptions,
        },
        Cell: ({cell}) => {
          const cellValue = cell.getValue<boolean>();
          const pillConfig = ActiveInactivePills(cellValue);
          return <Pill text={pillConfig.text} color={pillConfig.color} />;
        },
      },
    ],
    []
  );

  return columns;
};
